<template>
  <b-modal
    class="deleteAGMModal"
    title="Delete AGM"
    centered
    size="lg"
    ref="deleteAGMModal"
    ok-title="Confirm"
    cancel-title="Cancel"
    @open="open"
    @ok="handleOk"
  >
    <b-alert show variant="light"
      >Are you really gonna delete this marker?</b-alert
    >
    <b-loading :loading="processing" />
  </b-modal>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      processing: false,
      initial: null,
    };
  },
  computed: {
    ...mapGetters(['error', 'loading']),
  },
  methods: {
    open(payload) {
      this.resetFormFields();
      this.initial = { ...payload };
      this.$refs.deleteAGMModal.show();
    },
    close() {
      this.$refs.deleteAGMModal.hide();
    },
    validate() {
      this.form.error.name = !this.form.name;
    },
    handleOk(e) {
      e.preventDefault();
      this.onSubmit();
    },
    onSubmit() {
      this.onSubmitForm();
    },
    onCancel() {
      this.close();
    },
    onReset() {
      this.resetFormFields();
    },
    resetFormFields() {
      this.initial = null;
      this.processing = false;
    },
    onSubmitForm(e) {
      e && e.preventDefault();
      if (this.initial && !this.processing && !this.loading) {
        this.processing = true;
        this.$emit('delete', this.initial);
      }
    },
  },
  created() {
    this.resetFormFields();
  },
};
</script>
<style>
.deleteAGMModal .modal-header {
  border-bottom: 0 none;
}
.deleteAGMModal .form-control {
  border: solid 1px #ccc;
}
.deleteAGMModal .form-actions .btn {
  min-width: 100px;
}
</style>
